import { ArrowRightIcon } from '@heroicons/react/24/outline';

export function PrimaryButton({ children, onClick, href, className = '', ...rest }) {
  const content = (
    <>
      <span>{children}</span>
      <span className="pn-btn-icon" aria-hidden="true">
        <ArrowRightIcon className="h-4 w-4" strokeWidth={2} />
      </span>
    </>
  );
  if (href) {
    return (
      <a href={href} onClick={onClick} className={`pn-btn pn-btn-primary ${className}`} {...rest}>
        {content}
      </a>
    );
  }
  return (
    <button type="button" onClick={onClick} className={`pn-btn pn-btn-primary ${className}`} {...rest}>
      {content}
    </button>
  );
}

export function QuietButton({ children, onClick, href, className = '', ...rest }) {
  if (href) {
    return (
      <a href={href} onClick={onClick} className={`pn-btn pn-btn-quiet ${className}`} {...rest}>
        {children}
      </a>
    );
  }
  return (
    <button type="button" onClick={onClick} className={`pn-btn pn-btn-quiet ${className}`} {...rest}>
      {children}
    </button>
  );
}
